interface Props { enabled: boolean; onChange: (value: boolean) => void }

export function SoundToggle({ enabled, onChange }: Props) {
  return (
    <button
      className="sound-toggle"
      type="button"
      aria-pressed={enabled}
      onClick={() => onChange(!enabled)}
      title="首次点击后才会启用轻微反馈音"
    >
      <span className={`sound-icon ${enabled ? "is-on" : ""}`} aria-hidden="true"><i /><i /><i /></span>
      声音 {enabled ? "开" : "关"}
    </button>
  );
}
